import brandConfig from './brand.config.json';

type BrandKey = keyof typeof brandConfig;

const buildCompanies = () => {
  const entries = Object.entries(brandConfig) as [BrandKey, (typeof brandConfig)[BrandKey]][];
  return Object.fromEntries(
    entries.map(([key, cfg]) => [
      key,
      {
        companyMode: key,
        siteName: cfg.siteName,
        favicon: cfg.favicon,
        appleIcon: cfg.appleIcon,
      },
    ]),
  ) as Record<
    BrandKey,
    { companyMode: BrandKey; siteName: string; favicon: string; appleIcon: string }
  >;
};

export const companies = buildCompanies();

export type CompanyConfig = typeof companies.default;
